import { Card, PageHeader, Input, Select, Btn, Table } from "../../components/shared/UIComponents";

export function ManagerRegistration() {
  const managers = [
    { n: "ramesh", p: "737537642746", e: "", l: "Jagatpura" },
    { n: "krunal", p: "4666565465", e: "", l: "Jagatpura" },
    { n: "fayyaj", p: "9373243822", e: "xyz@gmail.com", l: "Belapur" },
    { n: "datta gore", p: "9865321456", e: "datta@gmail.com", l: "Airoli" },
  ];
  return (
    <Card>
      <PageHeader title="Manager Registration" />
      <div style={{ padding: 24 }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 16 }}>
          <Select label="Type of Login" options={["Select", "Manager", "Auditor", "Staff"]} />
          <Input label="Name" placeholder="Enter Name" />
          <Input label="UserName" placeholder="Enter UserName" />
          <Input label="Password" type="password" placeholder="Enter Password" />
          <Input label="Confirm Password" type="password" placeholder="Enter Confirm Password" />
          <Input label="Phone Number" placeholder="Enter Phone No" />
          <Input label="Email Address" placeholder="Enter EmailId" />
          <Select label="State" options={["Select", "Maharashtra", "Delhi", "Gujarat", "Karnataka", "Tamil Nadu"]} />
          <Select label="City" options={["Select", "Mumbai", "Pune", "Navi Mumbai", "Thane"]} />
          <Select label="Location" options={["Select", "Dombivali", "Kalyan", "Airoli", "Belapur", "Nerul"]} />
          <div style={{ gridColumn: "span 2", display: "flex", gap: 10 }}><Btn>Save</Btn><Btn bg="#42a5f5">Refresh</Btn></div>
        </div>
        <div style={{ fontWeight: 600, color: "#546e7a", fontSize: 13, marginBottom: 12 }}>📋 Manager Details</div>
        <Table columns={["SrNo", "Manager Name", "Phone", "Email", "Location", "Edit", "Delete"]} rows={managers}
          renderRow={(r, i) => [
            <td style={{ padding: "9px 12px" }}>{i + 1}</td>,
            <td style={{ padding: "9px 12px", fontWeight: 500 }}>{r.n}</td>,
            <td style={{ padding: "9px 12px" }}>{r.p}</td>,
            <td style={{ padding: "9px 12px", fontSize: 12 }}>{r.e}</td>,
            <td style={{ padding: "9px 12px" }}>{r.l}</td>,
            <td style={{ padding: "9px 12px" }}><button style={{ background: "#fff3e0", border: "none", borderRadius: 5, padding: "4px 8px", cursor: "pointer", fontSize: 12 }}>✏️</button></td>,
            <td style={{ padding: "9px 12px" }}><button style={{ background: "#fce8e6", border: "none", borderRadius: 5, padding: "4px 8px", cursor: "pointer", fontSize: 12 }}>🗑️</button></td>,
          ]}
        />
      </div>
    </Card>
  );
}

export function SetManager() {
  const societies = [
    { n: "Vitthal Plaza Co-Op Housing Society LTD", a: "balaji mandir Sagarli,Dombivali", sel: true },
    { n: "PARADISO BAY CO OPERATIVE SOCIETY LTD", a: "Plot no 415 416 alibag raigad 402201", sel: false },
    { n: "CHEMELI CO OPERATIVE HOUSING SOCIETY", a: "AMBHIKA NAGAR PAWER COMPLEX BELAVLI BADLAPUR WEST", sel: true },
    { n: "SocietyCity01", a: "P.D Cross road", sel: false },
    { n: "sawan avenue ashish", a: "Sector-19 Airoli Navi Mumbai", sel: false },
  ];
  return (
    <Card>
      <PageHeader title="Mapping/DeMapping Societies" />
      <div style={{ padding: 24 }}>
        <div style={{ display: "flex", gap: 14, alignItems: "flex-end", marginBottom: 20 }}>
          <Select label="" options={["rmsh-ramesh", "kr-krunal", "fy-fayyaj"]} style={{ minWidth: 200 }} />
          <Btn>Save</Btn>
        </div>
        <Table columns={["SrNo", "Select", "Name", "Address"]} rows={societies}
          renderRow={(r, i) => [
            <td style={{ padding: "9px 12px" }}>{i + 1}</td>,
            <td style={{ padding: "9px 12px" }}><input type="checkbox" defaultChecked={r.sel} style={{ accentColor: "#1565c0" }} /></td>,
            <td style={{ padding: "9px 12px", fontWeight: 500 }}>{r.n}</td>,
            <td style={{ padding: "9px 12px", fontSize: 12 }}>{r.a}</td>,
          ]}
        />
      </div>
    </Card>
  );
}

export function ManagerRights() {
  const modules = {
    Admin: ["Manage Society", "Email Configuration", "Manage Member", "Upload Documents", "Notice Manager", "Event Manager", "Helpdesk Tickets", "Sub Committee", "Assets Management", "Staff Management", "Add", "Delete"],
    Accounts: ["Vendor Management", "Set Account", "Account Master", "Budget", "Set Charges", "Bill Parameters", "Bill Generation", "Bank Reconciliation", "Add", "Delete"],
    Transactions: ["Transaction Menu", "Receipts", "Payments", "General Receipts", "Contra", "Debit Note/Credit Note/JV", "Add", "Delete", "Export To Excel"],
    Reports: ["Bank & Cash Reports", "Income & Expense Tracker", "Members Reports", "Final Accounts", "Finance Tracker", "Export To Excel"],
  };
  return (
    <Card>
      <PageHeader title="Set Manager Rights" />
      <div style={{ padding: 24 }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 14, marginBottom: 16 }}>
          <Select label="Select Type of Login" options={["Select", "Manager", "Auditor"]} />
          <Select label="Select User" options={["kr-krunal", "rmsh-ramesh", "fy-fayyaj"]} />
          <div style={{ display: "flex", alignItems: "flex-end", gap: 10 }}><Btn>Save</Btn><Btn bg="#f44336">Delete</Btn></div>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: 16 }}>
          {Object.entries(modules).map(([mod, items]) => (
            <div key={mod} style={{ border: "1px solid #e8eaf0", borderRadius: 10, overflow: "hidden" }}>
              <div style={{ background: "#f5f7fa", padding: "10px 14px", borderBottom: "1px solid #e8eaf0", display: "flex", alignItems: "center", gap: 8 }}>
                <input type="checkbox" style={{ accentColor: "#1565c0" }} defaultChecked />
                <span style={{ fontWeight: 600, color: "#1a2744", fontSize: 13 }}>{mod}</span>
              </div>
              <div style={{ padding: "8px 14px 12px" }}>
                {items.map(item => (
                  <label key={item} style={{ display: "flex", alignItems: "center", gap: 7, fontSize: 12.5, color: "#455a64", marginBottom: 6, cursor: "pointer" }}>
                    <input type="checkbox" style={{ accentColor: "#1565c0" }} />
                    {item}
                  </label>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
}

export default ManagerRegistration;
